<template>
  <div class="header">
    <router-link to="/" class="pt-20 d-flex align-items-center" style="gap: 20px;">
      <img alt="Uni logo" width="70" src="../assets/logo_tr.png">
      <img alt="Uni logo" height="50" src="../assets/sogu.svg">
      <img alt="Uni logo" src="../assets/logo.svg">
    </router-link>
    <main-menu />
    <div class="header__right d-flex align-items-center">
      <language-switcher />
    </div>
    <mobile-menu />
  </div>
</template>

<script>
import MainMenu from "./MainMenu.vue";
import MobileMenu from "./MobileMenu.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";

export default {
  name: "TplHeader",
  components: {MobileMenu, MainMenu, LanguageSwitcher}
}
</script>

<style scoped>
.header__right {
  margin-left: auto;
  margin-right: 20px;
  
  @media screen and (max-width: 1280px) {
    margin-right: 0;
  }
}
</style>